import React, { useEffect } from 'react';
import Contact from '../components/Contact';
import '../styles/lines.css'


const Work = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    return (
        <div>
            <div className='mt-32'>
                <img src="/bg-prop-2-right.svg" alt="codify" className="absolute top-0 right-0 -z-10 hidden lg:block" />
                <img src="/bg-prop-3-left.svg" alt="codify" className="absolute top-0 left-0 -z-10 hidden lg:block" />
                <div className="relative">
                    <h1 className="text-3xl sm:text-4xl md:text-6xl w-5/6 lg:w-1/2 md:w-5/6 pl-10 sm:pl-5 md:pl-10 lg:pl-48 mt-12 sm:mt-6 md:mt-12 lg:mt-40 sm:mb-8 text-[#0F172A] font-bold font-poppins  leading-snug sm:leading-tight">
                        We take digital experiences to the next level
                    </h1>
                    <p className="text-base sm:text-xl md:text-xl w-5/6 lg:w-1/2 md:w-5/6 pl-10 sm:pl-5 md:pl-10 lg:pl-48 font-poppins text-[#211E33] mb-4 sm:mb-6 leading-normal">
                        The products we build are changing the way industry leaders do their core business.
                    </p>
                </div>
            </div>
            <div className="relative bg-[#632dff] mt-32 overflow-hidden flex flex-col lg:flex-row items-center justify-between px-10 lg:px-20 min-h-[500px] lg:min-h-[600px]">
                {/* Text Section */}
                <div className="w-full lg:w-1/2 text-center lg:text-left mt-6 sm:mt-10">
                    <h1 className="text-2xl sm:text-2xl md:text-3xl text-white font-bold font-poppins leading-snug sm:leading-tight">
                        Blended Learning
                    </h1>
                    <p className="text-base sm:text-lg md:text-lg font-poppins text-white mt-4 leading-normal">
                        We leverage technology to revolutionize education by creating interactive, engaging, and adaptive learning experiences that bridge the gap between traditional and digital learning.
                    </p>
                </div>

                {/* Image Section */}
                <div className="w-full lg:w-1/2 flex justify-center lg:justify-end mt-6 lg:mt-0 mb-6 sm:mb-10">
                    <img src="/Blended_Learning.jpg" alt="blended learning" className="w-full max-w-md rounded-lg shadow-xl shadow-blue-gray-900/50 lg:max-w-lg object-cover" />
                </div>
            </div>

            <div className="relative bg-[#f8f9fc]  overflow-hidden flex flex-col-reverse lg:flex-row-reverse items-center justify-between px-10 lg:px-20 min-h-[500px] lg:min-h-[600px]">
                {/* Text Section */}
                <div className="w-full lg:w-1/2 text-center lg:text-left mb-6 sm:mb-10 ">
                    <h1 className="text-2xl sm:text-2xl md:text-3xl text-[#0f172a] font-bold font-poppins leading-snug sm:leading-tight">
                        ERP Systems
                    </h1>
                    <p className="text-base sm:text-lg md:text-lg font-poppins text-[#0f172a] mt-4 leading-normal">
                        Our solutions streamline business operations, improve efficiency, and enhance decision-making through robust Enterprise Resource Planning (ERP) systems tailored to diverse industries.
                    </p>
                </div>

                {/* Image Section */}
                <div className="w-full lg:w-1/2 flex justify-center lg:justify-start mt-6 sm:mt-10">
                    <img src="/ERP.jpg" alt="ERP Systems" className="w-full max-w-md rounded-lg shadow-xl shadow-blue-gray-900/50 lg:max-w-lg object-cover" />
                </div>
            </div>

            <div className="relative bg-[#d298fb] overflow-hidden flex flex-col lg:flex-row items-center justify-between px-10 lg:px-20 min-h-[500px] lg:min-h-[600px]">
                {/* Text Section */}
                <div className="w-full lg:w-1/2 text-center lg:text-left mt-6 sm:mt-10">
                    <h1 className="text-2xl sm:text-2xl md:text-3xl text-[#0f172a] font-bold font-poppins leading-snug sm:leading-tight">
                        E-commerce Solutions
                    </h1>
                    <p className="text-base sm:text-lg md:text-lg font-poppins text-[#0f172a] mt-4 leading-normal">
                        We develop scalable and secure e-commerce platforms that drive seamless online shopping experiences, optimizing sales, customer engagement, and business growth.
                    </p>
                </div>

                {/* Image Section */}
                <div className="w-full lg:w-1/2 flex justify-center lg:justify-end mt-6 lg:mt-0 mb-6 sm:mb-10">
                    <img src="/E-commerce.jpg" alt="e-commerce" className="w-full max-w-md rounded-lg shadow-xl shadow-blue-gray-900/50 lg:max-w-lg object-cover" />
                </div>
            </div>

            <div className="relative bg-[#141c25] overflow-hidden flex flex-col-reverse lg:flex-row-reverse items-center justify-between px-10 lg:px-20 min-h-[500px] lg:min-h-[600px]">
                {/* Text Section */}
                <div className="w-full lg:w-1/2 text-center lg:text-left mb-6 sm:mb-10 ">
                    <h1 className="text-2xl sm:text-2xl md:text-3xl text-white font-bold font-poppins leading-snug sm:leading-tight">
                        Artificial Intelligence
                    </h1>
                    <p className="text-base sm:text-lg md:text-lg font-poppins text-white mt-4 leading-normal">
                        From predictive analytics to machine learning models, we integrate AI-driven solutions that automate processes, enhance decision-making, and unlock new business opportunities.
                    </p>
                </div>

                {/* Image Section */}
                <div className="w-full lg:w-1/2 flex justify-center lg:justify-start mt-6 sm:mt-10">
                    <img src="/Artificial_Intelligence.jpg" alt="artificial intelligence" className="w-full max-w-md rounded-lg shadow-xl shadow-blue-gray-900/50 lg:max-w-lg object-cover" />
                </div>
            </div>

            <div className="relative bg-[#f4fafe] overflow-hidden flex flex-col lg:flex-row items-center justify-between px-10 lg:px-20 min-h-[500px] lg:min-h-[600px]">
                {/* Text Section */}
                <div className="w-full lg:w-1/2 text-center lg:text-left mt-6 sm:mt-10">
                    <h1 className="text-2xl sm:text-2xl md:text-3xl text-[#0f172a] font-bold font-poppins leading-snug sm:leading-tight">
                        Agricultural Technology
                    </h1>
                    <p className="text-base sm:text-lg md:text-lg font-poppins text-[#0f172a] mt-4 leading-normal">
                        We bring innovation to the agriculture sector with smart farming solutions, IoT-enabled monitoring, and AI-powered analytics to improve productivity and sustainability.
                    </p>
                </div>
                {/* Image Section */}
                <div className="w-full lg:w-1/2 flex justify-center lg:justify-end mt-6 lg:mt-0 mb-6 sm:mb-10">
                    <img src="/Agricultural_Technology.jpg" alt="agricultural technology" className="w-full max-w-md rounded-lg shadow-xl shadow-blue-gray-900/50 lg:max-w-lg object-cover" />
                </div>
            </div>

            <div className="relative bg-[#923184] overflow-hidden flex flex-col-reverse lg:flex-row-reverse items-center justify-between px-10 lg:px-20 min-h-[500px] lg:min-h-[600px]">
                {/* Text Section */}
                <div className="w-full lg:w-1/2 text-center lg:text-left mb-6 sm:mb-10 ">
                    <h1 className="text-2xl sm:text-2xl md:text-3xl text-white font-bold font-poppins leading-snug sm:leading-tight">
                        AEC & IT Integration
                    </h1>
                    <p className="text-base sm:text-lg md:text-lg font-poppins text-white mt-4 leading-normal">
                        By combining architecture, engineering, and construction (AEC) with cutting-edge technology, we drive efficiency, accuracy, and digital transformation in the construction industry.
                    </p>
                </div>

                {/* Image Section */}
                <div className="w-full lg:w-1/2 flex justify-center lg:justify-start mt-6 sm:mt-10">
                    <img src="/AEC_IT_Integration.jpg" alt="aec it integration" className="w-full max-w-md rounded-lg shadow-xl shadow-blue-gray-900/50 lg:max-w-lg object-cover" />
                </div>
            </div>

            <div className="relative bg-[#ffc67d] overflow-hidden flex flex-col lg:flex-row items-center justify-between px-10 lg:px-20 min-h-[500px] lg:min-h-[600px]">
                {/* Text Section */}
                <div className="w-full lg:w-1/2 text-center lg:text-left mt-6 sm:mt-10">
                    <h1 className="text-2xl sm:text-2xl md:text-3xl text-[#0f172a] font-bold font-poppins leading-snug sm:leading-tight">
                        Mechatronics
                    </h1>
                    <p className="text-base sm:text-lg md:text-lg font-poppins text-[#0f172a] mt-4 leading-normal">
                        We bridge the gap between mechanics, electronics, and computing, delivering intelligent automation, robotics, and smart systems for modern industries.
                    </p>
                </div>
                {/* Image Section */}
                <div className="w-full lg:w-1/2 flex justify-center lg:justify-end mt-6 lg:mt-0 mb-6 sm:mb-10">
                    <img src="/Mechatronics.jpg" alt="mechatronics" className="w-full max-w-md rounded-lg shadow-xl shadow-blue-gray-900/50 lg:max-w-lg object-cover" />
                </div>
            </div>
            <Contact/>
            <div className='mt-48'/>
        </div>
    );
};

export default Work;
